import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { useTableContext } from './Table';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledTR = /*#__PURE__*/styled.tr.withConfig({
  displayName: "Row__StyledTR",
  componentId: "components-web__sc-6pbb9a-0"
})(["&:hover{background-color:", " !important;}border-style:", ";border-color:", ";border-width:", "px;border-top-width:", "px;"], _ref => {
  let {
    tokens
  } = _ref;
  return tokens?.rowHoverBackgroundColor;
}, _ref2 => {
  let {
    tokens
  } = _ref2;
  return tokens?.rowBorderWidth || tokens?.rowBorderTopWidth ? 'solid' : 'none';
}, _ref3 => {
  let {
    tokens
  } = _ref3;
  return tokens?.rowBorderColor;
}, _ref4 => {
  let {
    tokens
  } = _ref4;
  return `${tokens?.rowBorderWidth}` || 0;
}, _ref5 => {
  let {
    tokens
  } = _ref5;
  return `${tokens?.rowBorderTopWidth}` || tokens?.rowBorderWidth;
});
const Row = /*#__PURE__*/React.forwardRef((_ref6, ref) => {
  let {
    children,
    tokens: rowTokens
  } = _ref6;
  const {
    themeTokens
  } = useTableContext();
  const mergedTokens = {
    ...themeTokens,
    ...rowTokens
  };
  return /*#__PURE__*/_jsx(StyledTR, {
    ref: ref,
    tokens: mergedTokens,
    children: React.Children.map(children, (child, index) => /*#__PURE__*/React.cloneElement(child, {
      isFirstInRow: index === 0
    }))
  });
});
Row.displayName = 'Row';
Row.propTypes = {
  tokens: PropTypes.shape({
    borderColor: PropTypes.string,
    topBorderWidth: PropTypes.string,
    bottomBorderWidth: PropTypes.string,
    leftBorderWidth: PropTypes.string,
    rightBorderWidth: PropTypes.string,
    rowHoverBackgroundColor: PropTypes.string
  }),
  children: PropTypes.node
};
export default Row;